module.exports = __webpack_public_path__ + "img/sivram.287791ec.webp";